import { createMuiTheme } from "@material-ui/core/styles";

const theme = createMuiTheme({
    palette: {
        primary: {
            main: "#2E56F4",
            dark: "#1642f3",
        },
        secondary: {
            main: "#f50057",
        },
        background: {
            default: "#F2F5F8"
        },
        text: {
            primary: "#39424D",
            secondary: "#6B747F"
        }
    },
    typography: {
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        h4: {
            fontWeight: 600,
            color: "#2E56F4"
        },
        h6: {
            fontWeight: 500,
            color: "#39424D"
        },
        body1: {
            fontSize: '16px',
            lineHeight: 1.5
        },
        body2: {
            fontSize: '14px',
            lineHeight: 1.4
        }
    },
    shape: {
        borderRadius: 8,
    },
    overrides: {
        MuiButton: {
            root: {
                textTransform: 'none', // Prevent automatic uppercase transformation
            },
        },
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 960,
            lg: 1280,
            xl: 1920,
        },
    },
    spacing: 8,
});

export default theme;
